const Spinner = () => {
  return (
    <div className="w-8 h-8 border-4 border-blue-200 border-t-blue-500 rounded-full animate-spin"></div>
  )
}

export default Spinner
